import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  doorControls: [],
  totalElements: 0,
  createdId: null,
  controllers: [],
  controllersTotalElements: 0,
  availableControllers: [],
  availableControllersTotalElements: 0,
});

const { Types, Creators } = createActions({
  getDoorControlsRequest: ['pageParams', 'customerId'],
  getDoorControlsRequestSuccess: ['doorControls', 'totalElements'],
  getDoorControlsRequestFailure: ['errorMessage'],

  createDoorControlRequest: ['doorControlInfo', 'controllers', 'doorControlParams', 'controllersParams', 'customerId'],
  createDoorControlRequestSuccess: [
    'createdId',
    'doorControls',
    'totalElements',
    'controllers',
    'controllersTotalElements',
    'successMessage',
  ],
  createDoorControlRequestFailure: ['errorMessage'],

  editDoorControlRequest: ['doorControlInfo', 'pageParams', 'customerId'],
  editDoorControlRequestSuccess: ['doorControls', 'totalElements', 'successMessage'],
  editDoorControlRequestFailure: ['errorMessage'],

  deleteDoorControlRequest: ['doorControlId', 'pageParams', 'customerId'],
  deleteDoorControlRequestSuccess: ['doorControls', 'totalElements', 'successMessage'],
  deleteDoorControlRequestFailure: ['errorMessage'],

  getAvailableControllersRequest: ['pageParams', 'customerId'],
  getAvailableControllersRequestSuccess: ['availableControllers', 'availableControllersTotalElements'],
  getAvailableControllersRequestFailure: ['errorMessage'],

  getDoorControlControllersRequest: ['doorControlId', 'pageParams'],
  getDoorControlControllersRequestSuccess: ['controllers', 'controllersTotalElements'],
  getDoorControlControllersRequestFailure: ['errorMessage'],

  addDoorControlControllersRequest: ['doorControlId', 'controllers', 'pageParams'],
  addDoorControlControllersRequestSuccess: ['controllers', 'controllersTotalElements', 'successMessage'],
  addDoorControlControllersRequestFailure: ['errorMessage'],

  editDoorControlControllersRequest: ['doorControlId', 'controllers', 'pageParams'],
  editDoorControlControllersRequestSuccess: ['controllers', 'controllersTotalElements', 'successMessage'],
  editDoorControlControllersRequestFailure: ['errorMessage'],

  deleteDoorControlControllersRequest: ['doorControlId', 'controllers', 'pageParams'],
  deleteDoorControlControllersRequestSuccess: ['controllers', 'controllersTotalElements', 'successMessage'],
  deleteDoorControlControllersRequestFailure: ['errorMessage'],

  resetDoorControls: null,
  resetControllers: null,
  resetAvailableControllers: null,
});

export const getDoorControlsRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getDoorControlsRequestSuccess = (state, { doorControls, totalElements }) =>
  state.merge({ isLoading: false, doorControls, totalElements });
export const getDoorControlsRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const createDoorControlRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createDoorControlRequestSuccess = (
  state,
  { createdId, doorControls, totalElements, controllers, controllersTotalElements, successMessage }
) =>
  state.merge({
    isLoading: false,
    createdId,
    doorControls,
    totalElements,
    controllers,
    controllersTotalElements,
    successMessage,
  });
export const createDoorControlRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editDoorControlRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editDoorControlRequestSuccess = (state, { doorControls, totalElements, successMessage }) =>
  state.merge({ isLoading: false, doorControls, totalElements, successMessage });
export const editDoorControlRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteDoorControlRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteDoorControlRequestSuccess = (state, { doorControls, totalElements, successMessage }) =>
  state.merge({ isLoading: false, doorControls, totalElements, successMessage });
export const deleteDoorControlRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getAvailableControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getAvailableControllersRequestSuccess = (
  state,
  { availableControllers, availableControllersTotalElements }
) => state.merge({ isLoading: false, availableControllers, availableControllersTotalElements });
export const getAvailableControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getDoorControlControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getDoorControlControllersRequestSuccess = (state, { controllers, controllersTotalElements }) =>
  state.merge({ isLoading: false, controllers, controllersTotalElements });
export const getDoorControlControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const addDoorControlControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const addDoorControlControllersRequestSuccess = (
  state,
  { controllers, controllersTotalElements, successMessage }
) => state.merge({ isLoading: false, controllers, controllersTotalElements, successMessage });
export const addDoorControlControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editDoorControlControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editDoorControlControllersRequestSuccess = (
  state,
  { controllers, controllersTotalElements, successMessage }
) => state.merge({ isLoading: false, controllers, controllersTotalElements, successMessage });
export const editDoorControlControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteDoorControlControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteDoorControlControllersRequestSuccess = (
  state,
  { controllers, controllersTotalElements, successMessage }
) => state.merge({ isLoading: false, controllers, controllersTotalElements, successMessage });
export const deleteDoorControlControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const resetDoorControls = (state) => state.merge({ doorControls: [], totalElements: 0 });
export const resetControllers = (state) => state.merge({ controllers: [], controllersTotalElements: 0 });
export const resetAvailableControllers = (state) =>
  state.merge({ availableControllers: [], availableControllersTotalElements: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_DOOR_CONTROLS_REQUEST]: getDoorControlsRequest,
  [Types.GET_DOOR_CONTROLS_REQUEST_SUCCESS]: getDoorControlsRequestSuccess,
  [Types.GET_DOOR_CONTROLS_REQUEST_FAILURE]: getDoorControlsRequestFailure,

  [Types.CREATE_DOOR_CONTROL_REQUEST]: createDoorControlRequest,
  [Types.CREATE_DOOR_CONTROL_REQUEST_SUCCESS]: createDoorControlRequestSuccess,
  [Types.CREATE_DOOR_CONTROL_REQUEST_FAILURE]: createDoorControlRequestFailure,

  [Types.EDIT_DOOR_CONTROL_REQUEST]: editDoorControlRequest,
  [Types.EDIT_DOOR_CONTROL_REQUEST_SUCCESS]: editDoorControlRequestSuccess,
  [Types.EDIT_DOOR_CONTROL_REQUEST_FAILURE]: editDoorControlRequestFailure,

  [Types.DELETE_DOOR_CONTROL_REQUEST]: deleteDoorControlRequest,
  [Types.DELETE_DOOR_CONTROL_REQUEST_SUCCESS]: deleteDoorControlRequestSuccess,
  [Types.DELETE_DOOR_CONTROL_REQUEST_FAILURE]: deleteDoorControlRequestFailure,

  [Types.GET_AVAILABLE_CONTROLLERS_REQUEST]: getAvailableControllersRequest,
  [Types.GET_AVAILABLE_CONTROLLERS_REQUEST_SUCCESS]: getAvailableControllersRequestSuccess,
  [Types.GET_AVAILABLE_CONTROLLERS_REQUEST_FAILURE]: getAvailableControllersRequestFailure,

  [Types.GET_DOOR_CONTROL_CONTROLLERS_REQUEST]: getDoorControlControllersRequest,
  [Types.GET_DOOR_CONTROL_CONTROLLERS_REQUEST_SUCCESS]: getDoorControlControllersRequestSuccess,
  [Types.GET_DOOR_CONTROL_CONTROLLERS_REQUEST_FAILURE]: getDoorControlControllersRequestFailure,

  [Types.ADD_DOOR_CONTROL_CONTROLLERS_REQUEST]: addDoorControlControllersRequest,
  [Types.ADD_DOOR_CONTROL_CONTROLLERS_REQUEST_SUCCESS]: addDoorControlControllersRequestSuccess,
  [Types.ADD_DOOR_CONTROL_CONTROLLERS_REQUEST_FAILURE]: addDoorControlControllersRequestFailure,

  [Types.EDIT_DOOR_CONTROL_CONTROLLERS_REQUEST]: editDoorControlControllersRequest,
  [Types.EDIT_DOOR_CONTROL_CONTROLLERS_REQUEST_SUCCESS]: editDoorControlControllersRequestSuccess,
  [Types.EDIT_DOOR_CONTROL_CONTROLLERS_REQUEST_FAILURE]: editDoorControlControllersRequestFailure,

  [Types.DELETE_DOOR_CONTROL_CONTROLLERS_REQUEST]: deleteDoorControlControllersRequest,
  [Types.DELETE_DOOR_CONTROL_CONTROLLERS_REQUEST_SUCCESS]: deleteDoorControlControllersRequestSuccess,
  [Types.DELETE_DOOR_CONTROL_CONTROLLERS_REQUEST_FAILURE]: deleteDoorControlControllersRequestFailure,

  [Types.RESET_DOOR_CONTROLS]: resetDoorControls,
  [Types.RESET_CONTROLLERS]: resetControllers,
  [Types.RESET_AVAILABLE_CONTROLLERS]: resetAvailableControllers,
});

export const DoorControlsTypes = Types;
export default Creators;
